export const AuthorSkeleton = () => {
  return (
    <div className="author">
      <div className="author__avatar">
        <span
          className="vtmn-skeleton vtmn-skeleton_avatar"
          style={{ width: '40px', height: '40px' }}
        />
      </div>
      <div className="author__content">
        <span
          className="vtmn-skeleton vtmn-skeleton_line"
          style={{ width: '187px', height: '24px' }}
        />
      </div>
    </div>
  );
};
